<template>
      <!-- 侧边栏 -->
      <el-aside :width="isCollapse ? '64px' : '180px'">
        <div class="toggle-button" @click="toggleCollapse">|||</div>
        <!-- 侧边栏区域 -->
        <el-menu background-color="#333744" text-color="#fff"
        active-text-color="#409eff" :collapse="isCollapse"
        :collapse-transition="false" router
        :default-active="activePath">
          <!-- 一级菜单 -->
          <el-menu-item index="factories" @click="saveNavState('factories')">
            <i :class="iconsObj[103]"></i>
            <span slot="title">工厂管理</span>
          </el-menu-item>
          <el-menu-item index="machines" @click="saveNavState('machines')">
            <i :class="iconsObj[145]"></i>
            <span slot="title">机台列表</span>
          </el-menu-item>
          <el-menu-item v-if="this.username=='admin'" v-show="isSuper" index="platformadmin" @click="saveNavState('platformadmin')">
            <i :class="iconsObj[115]"></i>
            <span slot="title">平台管理员</span>
          </el-menu-item>
           <el-menu-item index="personcentral" @click="saveNavState('personcentral')">
            <i :class="iconsObj[125]"></i>
            <span slot="title">个人中心</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
</template>

<script>
export default {
   data() {
       return {
      isSuper: true,
      // 左侧菜单数据
      // menulist: [],
      iconsObj: {
        // eslint-disable-next-line quote-props
        '125': 'iconfont icon-user',
        // eslint-disable-next-line quote-props
        '103': 'iconfont icon-tijikongjian',
        // eslint-disable-next-line quote-props
        '101': 'iconfont icon-shangpin',
        // eslint-disable-next-line quote-props
        '102': 'iconfont icon-danju',
        // eslint-disable-next-line quote-props
        '145': 'iconfont icon-baobiao',
        // eslint-disable-next-line quote-props
        '115': 'iconfont iconjiaoseguanli2'
      },
      // 是否折叠
      isCollapse: false,
     // 被激活的链接地址
      activePath: '',
      username: ''
       }
   },
   methods: {
             // 获取所有的菜单
    // async getMenuList () {
    //   const { data: res } = await this.$http.get('menus')
    //   if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
    //   this.menulist = res.data
    //   console.log(res)
    // },
    //  点击按钮，切换菜单的折叠与展开
    toggleCollapse () {
      this.isCollapse = !this.isCollapse
    },
    // 保存链接的激活状态
    saveNavState (activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
    },
       judgeAdmin() {
      if (this.username !== 'admin') {
        this.isSuper = false
      }
    }
   },
   created() {
    this.username = window.sessionStorage.getItem('username')
    this.judgeAdmin()
    // this.getMenuList()
    this.activePath = window.sessionStorage.getItem('activePath')
    // this.getUserInfo()
   }
}
</script>

<style lang="less" scoped>

.el-aside {
  background-color: #333744;
  .el-menu {
    border-right: none;
  }
}
.el-main {
  background-color: #EAEDF1;
}
.toggle-button {
  background-color: #4a5064;
  font-size: 10px;
  line-height: 24px;
  color: #fff;
  text-align: center;
  letter-spacing: 0.2em;
  cursor: pointer;//使其变成可点击
}
</style>
